import { render, staticRenderFns } from "./UsuarioForm.vue?vue&type=template&id=032280ac&scoped=true"
import script from "./UsuarioForm.vue?vue&type=script&lang=js"
export * from "./UsuarioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032280ac",
  null
  
)

export default component.exports